import { render, staticRenderFns } from "./VerticalPlanIcon.vue?vue&type=template&id=8b0ea1a0&scoped=true&"
import script from "./VerticalPlanIcon.vue?vue&type=script&lang=js&"
export * from "./VerticalPlanIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0ea1a0",
  null
  
)

export default component.exports